import { zodTransformFirestoreTimestampToDate } from "../../../utils/zodUtils.mjs";
import { zodFlavorId } from "../../ids.mjs";
import { defineFirestoreCollection } from "../../firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "../../meta.mjs";
import { executionTraceStampSchema } from "../../executionTrace.mjs";
import { bridgeServiceEligibilityStatusPollSchema } from "./consultSyncTargets.mjs";
import { VendorSyncOps } from "../../vendorSync/vendorSync.mjs";
import { bridgePatientResponsibilityBreakdownSchema } from "./patientResponsibility.mjs";
import { z as z$1 } from "zod";

// src/models/vendors/bridge/serviceEligibility.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate);
/** Bridge ServiceEligibility v2 status values observed from Bridge API. */
const bridgeServiceEligibilityStatusSchema = z$1.enum([
	"PENDING",
	"ELIGIBLE",
	"INELIGIBLE",
	"UNKNOWN",
	"UNINSURED",
	"INEFFECTIVE"
]);
/**
* Bridge service eligibility observed doc — doc id = opaque sync id.
* Path: `bridge_service_eligibilities/{syncId}`.
*/
const bridgeServiceEligibilitySchema = z$1.object({
	id: zodFlavorId(),
	customerId: zodFlavorId(),
	consultationId: zodFlavorId().optional(),
	policyId: zodFlavorId().optional(),
	vendorNativeId: zodFlavorId().optional(),
	status: bridgeServiceEligibilityStatusSchema,
	dateOfService: z$1.string().optional(),
	serviceTypeId: z$1.string().optional(),
	state: z$1.string().optional(),
	patientResponsibility: z$1.number().int().nonnegative().optional(),
	patientResponsibilityBreakdown: bridgePatientResponsibilityBreakdownSchema.optional(),
	statusPoll: bridgeServiceEligibilityStatusPollSchema.optional(),
	snapshot: meta(z$1.record(z$1.string(), z$1.unknown()).optional(), {
		bqType: "stringified_map",
		pii: { category: "health" }
	}),
	observedAt: firestoreDate.optional(),
	createdAt: firestoreDate,
	updatedAt: firestoreDate,
	executionTrace: executionTraceStampSchema.optional()
});
/** Parse Hard SE `snapshot.providers[]` Bridge `prv_` ids; tolerates untyped snapshot. */
function parseBridgeServiceEligibilitySnapshotProviderIds(snapshot) {
	if (!snapshot) return [];
	const providers = snapshot["providers"];
	if (!Array.isArray(providers)) return [];
	const ids = [];
	for (const entry of providers) {
		if (!entry || typeof entry !== "object") continue;
		const id = entry.id;
		if (typeof id === "string" && id.startsWith("prv_")) ids.push(id);
	}
	return ids;
}
const BridgeServiceEligibilities = defineFirestoreCollection("bridge_service_eligibilities", bridgeServiceEligibilitySchema, { ops: VendorSyncOps }, {
	dwReplication: true,
	firestoreCollectionPath: "bridge_service_eligibilities",
	executionTrace: true
});

export { BridgeServiceEligibilities, bridgeServiceEligibilitySchema, bridgeServiceEligibilityStatusSchema, parseBridgeServiceEligibilitySnapshotProviderIds };
//# sourceMappingURL=serviceEligibility.mjs.map